import siteContent from "@config/site-content.json";
import SectionTitle from "../components/SectionTitle.jsx";

export default function About({ t, branding }) {
  return (
    <section className="section-shell py-14">
      <SectionTitle
        title={branding.legalName}
        text={siteContent.about.overview}
      />

      <div className="grid gap-5 md:grid-cols-3">
        <article className="premium-card p-6">
          <h2 className="text-2xl font-black text-royal">Vision</h2>
          <p className="mt-3 leading-7 text-muted">
            {siteContent.about.vision}
          </p>
        </article>

        <article className="premium-card p-6">
          <h2 className="text-2xl font-black text-royal">Mission</h2>
          <p className="mt-3 leading-7 text-muted">
            {siteContent.about.mission}
          </p>
        </article>

        <article className="premium-card p-6">
          <h2 className="text-2xl font-black text-royal">Values</h2>
          <p className="mt-3 leading-7 text-muted">
            {siteContent.about.values.join(" • ")}
          </p>
        </article>
      </div>

      <div className="mt-10 grid gap-5 lg:grid-cols-[1.2fr_1fr]">
        
        {/* Founder Section */}
        <article className="premium-card p-6">
          <div className="grid gap-6 md:grid-cols-[220px_1fr] items-start">

            <img
              src={branding.founder.image}
              alt={branding.founder.alt}
              className="w-full rounded-xl shadow-lg object-cover border border-[var(--line)]"
            />

            <div>
              <p className="text-sm font-black uppercase tracking-[0.18em] text-orange">
                {t.home.founder}
              </p>

              <h2 className="mt-2 text-3xl font-black text-royal">
                {branding.founder.name}
              </h2>

              <p className="mt-1 text-base font-semibold text-orange">
                {branding.founder.title}
              </p>

              <div className="mt-4 h-1 w-20 rounded-full bg-orange"></div>

              <p className="mt-5 leading-7 text-muted whitespace-pre-line">
                {branding.founder.message}
              </p>
            </div>

          </div>
        </article>

        {/* Growth Timeline */}
        <div className="premium-card p-6">
          <h2 className="mb-5 text-2xl font-black text-royal">
            Growth Timeline
          </h2>

          <div className="grid gap-4">
            {siteContent.timeline.map((item) => (
              <div
                key={item.year}
                className="rounded-sur border border-[var(--line)] p-4"
              >
                <span className="text-sm font-black text-orange">
                  {item.year}
                </span>

                <h3 className="text-lg font-black text-ink">
                  {item.title}
                </h3>

                <p className="text-sm leading-6 text-muted">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
